import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IAlacakCekSenetList_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IAlacakCekSenetList_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  Boss_VCreditCheques: any[];
  Boss_VCreditCheques_dummy: any[];
  Boss_VCreditChequesTotal: any[];
  Boss_VCreditChequesTotal_dummy: any[];
  GetVendorAccounts: any[];
  GetVendorAccounts_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
}

export class AlacakCekSenetList_ScreenBase extends React.PureComponent<
  IAlacakCekSenetList_ScreenProps,
  any
> {
  alacakceksenetlist_411475_value_kuikaSelectBoxRef: React.RefObject<any>;
  alacakceksenetlist_760966_value_kuikaAutoCompleteRef: React.RefObject<any>;
  alacakceksenetlist_30934_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "55aad852-6a05-47c6-971c-34ed3d29e281",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 208607, PropertyName: "label", Value: "Profil" },
        { Id: 240400, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 289145, PropertyName: "value", Value: "Alacak Çek/Senet" },
        { Id: 411475, PropertyName: "placeholder", Value: "Çek/Senet Tipi..." },
        { Id: 760966, PropertyName: "placeholder", Value: "Cari Ünvanı..." },
        { Id: 621226, PropertyName: "value", Value: "Toplam Çek Sayısı" },
        { Id: 887540, PropertyName: "value", Value: "adet" },
        { Id: 93650, PropertyName: "value", Value: "Toplam Tutar" },
        {
          Id: 30934,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 643141, PropertyName: "title", Value: "Title" },
        { Id: 613401, PropertyName: "value", Value: "Tipi" },
        { Id: 940110, PropertyName: "value", Value: "[datafield:tipi]" },
        { Id: 962232, PropertyName: "value", Value: "Tarih" },
        { Id: 397556, PropertyName: "value", Value: "[datafield:tarih]" },
        { Id: 153110, PropertyName: "value", Value: "Vade Tarihi" },
        { Id: 241699, PropertyName: "value", Value: "[datafield:vade]" },
        { Id: 274527, PropertyName: "value", Value: "Cari Ünvanı" },
        { Id: 486428, PropertyName: "value", Value: "[datafield:cariunvani]" },
        { Id: 292546, PropertyName: "value", Value: "Çek No" },
        { Id: 644066, PropertyName: "value", Value: "[datafield:cekno]" },
        { Id: 264349, PropertyName: "value", Value: "Tutar" },
        { Id: 519596, PropertyName: "value", Value: "[datafield:tutar]" },
        { Id: 18531, PropertyName: "value", Value: "Durum" },
        { Id: 331069, PropertyName: "value", Value: "[datafield:durumu]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.alacakceksenetlist_411475_value_kuikaSelectBoxRef = React.createRef();
    this.alacakceksenetlist_760966_value_kuikaAutoCompleteRef =
      React.createRef();
    this.alacakceksenetlist_30934_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      Boss_VCreditCheques: [],
      Boss_VCreditChequesTotal: [],
      GetVendorAccounts: [],
      GetImage: [],
      dataSource_411475: [
        { key: "Hepsi", text: "Hepsi" },
        { key: "Çek", text: "Çek" },
        { key: "Senet", text: "Senet" },
      ],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("alacakceksenetlist", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.AlacakCekSenetListPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("alacakceksenetlist", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("alacakceksenetlist", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.AlacakCekSenetListPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  AlacakCekSenetListPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      customerCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      type_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlacakCekSenetList/AlacakCekSenetListPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VCreditCheques = result?.data.boss_VCreditCheques;

    stateVars.Boss_VCreditChequesTotal = result?.data.boss_VCreditChequesTotal;
    formVars.alacakceksenetlist_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCreditChequesTotal !== undefined
        ? stateVars.Boss_VCreditChequesTotal?.length > 0
          ? stateVars.Boss_VCreditChequesTotal[0].cekAdeti
          : null
        : this.state.Boss_VCreditChequesTotal?.length > 0
        ? this.state.Boss_VCreditChequesTotal[0].cekAdeti
        : null
    );
    formVars.alacakceksenetlist_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCreditChequesTotal !== undefined
        ? stateVars.Boss_VCreditChequesTotal?.length > 0
          ? stateVars.Boss_VCreditChequesTotal[0].tutar
          : null
        : this.state.Boss_VCreditChequesTotal?.length > 0
        ? this.state.Boss_VCreditChequesTotal[0].tutar
        : null
    );
    stateVars.GetVendorAccounts = result?.data.getVendorAccounts;

    formVars.alacakceksenetlist_760966_value =
      stateVars.GetVendorAccounts !== undefined
        ? stateVars.GetVendorAccounts?.length > 0
          ? stateVars.GetVendorAccounts[0].currAccDescription
          : null
        : this.state.GetVendorAccounts?.length > 0
        ? this.state.GetVendorAccounts[0].currAccDescription
        : null;
    formVars.alacakceksenetlist_760966_options = stateVars.GetVendorAccounts;
    stateVars.GetImage = result?.data.getImage;
    formVars.alacakceksenetlist_774367_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AlacakCekSenetListPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlacakCekSenetListPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.alacakceksenetlist_774367_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    formVars.alacakceksenetlist_760966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetVendorAccounts !== undefined
        ? stateVars.GetVendorAccounts?.length > 0
          ? stateVars.GetVendorAccounts[0].currAccDescription
          : null
        : this.state.GetVendorAccounts?.length > 0
        ? this.state.GetVendorAccounts[0].currAccDescription
        : null
    );

    formVars.alacakceksenetlist_760966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetVendorAccounts !== undefined
        ? stateVars.GetVendorAccounts?.length > 0
          ? stateVars.GetVendorAccounts[0].currAccDescription
          : null
        : this.state.GetVendorAccounts?.length > 0
        ? this.state.GetVendorAccounts[0].currAccDescription
        : null
    );

    stateVars.dataSource_760966 =
      stateVars.GetVendorAccounts ?? this.state.GetVendorAccounts;
    stateVars.dataSource_760966 =
      stateVars.GetVendorAccounts ?? this.state.GetVendorAccounts;
    formVars.alacakceksenetlist_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCreditChequesTotal !== undefined
        ? stateVars.Boss_VCreditChequesTotal?.length > 0
          ? stateVars.Boss_VCreditChequesTotal[0].cekAdeti
          : null
        : this.state.Boss_VCreditChequesTotal?.length > 0
        ? this.state.Boss_VCreditChequesTotal[0].cekAdeti
        : null
    );

    formVars.alacakceksenetlist_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCreditChequesTotal !== undefined
        ? stateVars.Boss_VCreditChequesTotal?.length > 0
          ? stateVars.Boss_VCreditChequesTotal[0].tutar
          : null
        : this.state.Boss_VCreditChequesTotal?.length > 0
        ? this.state.Boss_VCreditChequesTotal[0].tutar
        : null
    );

    stateVars.dataSource_30934 =
      stateVars.Boss_VCreditCheques ?? this.state.Boss_VCreditCheques;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  AlacakCekSenetListComponent_548561_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AlacakCekSenetList",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "275368",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlacakCekSenetListComponent_208607_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AlacakCekSenetList",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlacakCekSenetListComponent_240400_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlacakCekSenetListComponent_411475_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alacakceksenetlist_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alacakceksenetlist_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      customerCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alacakceksenetlist_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      type_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alacakceksenetlist_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlacakCekSenetList/AlacakCekSenetListComponent_411475_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VCreditCheques = result?.data.boss_VCreditCheques;

    stateVars.Boss_VCreditChequesTotal = result?.data.boss_VCreditChequesTotal;
    formVars.alacakceksenetlist_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCreditChequesTotal !== undefined
        ? stateVars.Boss_VCreditChequesTotal?.length > 0
          ? stateVars.Boss_VCreditChequesTotal[0].cekAdeti
          : null
        : this.state.Boss_VCreditChequesTotal?.length > 0
        ? this.state.Boss_VCreditChequesTotal[0].cekAdeti
        : null
    );
    formVars.alacakceksenetlist_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCreditChequesTotal !== undefined
        ? stateVars.Boss_VCreditChequesTotal?.length > 0
          ? stateVars.Boss_VCreditChequesTotal[0].tutar
          : null
        : this.state.Boss_VCreditChequesTotal?.length > 0
        ? this.state.Boss_VCreditChequesTotal[0].tutar
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.AlacakCekSenetListComponent_411475_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlacakCekSenetListComponent_411475_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.alacakceksenetlist_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCreditChequesTotal !== undefined
        ? stateVars.Boss_VCreditChequesTotal?.length > 0
          ? stateVars.Boss_VCreditChequesTotal[0].cekAdeti
          : null
        : this.state.Boss_VCreditChequesTotal?.length > 0
        ? this.state.Boss_VCreditChequesTotal[0].cekAdeti
        : null
    );

    formVars.alacakceksenetlist_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCreditChequesTotal !== undefined
        ? stateVars.Boss_VCreditChequesTotal?.length > 0
          ? stateVars.Boss_VCreditChequesTotal[0].tutar
          : null
        : this.state.Boss_VCreditChequesTotal?.length > 0
        ? this.state.Boss_VCreditChequesTotal[0].tutar
        : null
    );

    stateVars.dataSource_30934 =
      stateVars.Boss_VCreditCheques ?? this.state.Boss_VCreditCheques;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlacakCekSenetListComponent_760966_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alacakceksenetlist_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      type_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alacakceksenetlist_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      customerCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alacakceksenetlist_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      type_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alacakceksenetlist_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlacakCekSenetList/AlacakCekSenetListComponent_760966_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VCreditCheques = result?.data.boss_VCreditCheques;

    stateVars.Boss_VCreditChequesTotal = result?.data.boss_VCreditChequesTotal;
    formVars.alacakceksenetlist_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCreditChequesTotal !== undefined
        ? stateVars.Boss_VCreditChequesTotal?.length > 0
          ? stateVars.Boss_VCreditChequesTotal[0].cekAdeti
          : null
        : this.state.Boss_VCreditChequesTotal?.length > 0
        ? this.state.Boss_VCreditChequesTotal[0].cekAdeti
        : null
    );
    formVars.alacakceksenetlist_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCreditChequesTotal !== undefined
        ? stateVars.Boss_VCreditChequesTotal?.length > 0
          ? stateVars.Boss_VCreditChequesTotal[0].tutar
          : null
        : this.state.Boss_VCreditChequesTotal?.length > 0
        ? this.state.Boss_VCreditChequesTotal[0].tutar
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.AlacakCekSenetListComponent_760966_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlacakCekSenetListComponent_760966_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.alacakceksenetlist_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCreditChequesTotal !== undefined
        ? stateVars.Boss_VCreditChequesTotal?.length > 0
          ? stateVars.Boss_VCreditChequesTotal[0].cekAdeti
          : null
        : this.state.Boss_VCreditChequesTotal?.length > 0
        ? this.state.Boss_VCreditChequesTotal[0].cekAdeti
        : null
    );

    formVars.alacakceksenetlist_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCreditChequesTotal !== undefined
        ? stateVars.Boss_VCreditChequesTotal?.length > 0
          ? stateVars.Boss_VCreditChequesTotal[0].tutar
          : null
        : this.state.Boss_VCreditChequesTotal?.length > 0
        ? this.state.Boss_VCreditChequesTotal[0].tutar
        : null
    );

    stateVars.dataSource_30934 =
      stateVars.Boss_VCreditCheques ?? this.state.Boss_VCreditCheques;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [275368] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.AlacakCekSenetListPageInit();
    }
  }
}
